export default function SafetySection() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20flat%20lay%20of%20a%20modern%20laptop%20displaying%20a%20secure%20shopping%20checklist%20interface%20on%20screen%20with%20a%20padlock%20symbol%20visible%2C%20a%20coffee%20cup%20and%20minimalist%20notebook%20beside%20it%20on%20a%20light%20cream%20desk%2C%20soft%20natural%20lighting%20from%20window%2C%20warm%20neutral%20tones%2C%20editorial%20workspace%20photography&width=900&height=700&seq=safety-img-v3&orientation=landscape"
                alt="Compra Segura com Hoobuy Spreadsheet"
                title="Segurança no Hoobuy Spreadsheet"
                className="w-full h-auto object-cover"
              />
              <div className="absolute top-4 left-4 flex gap-2 flex-wrap">
                <span className="px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-semibold text-foreground-800 whitespace-nowrap">
                  Seguro
                </span>
                <span className="px-3 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm text-xs font-semibold text-foreground-800 whitespace-nowrap">
                  Verificado
                </span>
                <span className="px-3 py-1.5 rounded-full bg-primary-500/80 backdrop-blur-sm text-xs font-semibold text-background-50 whitespace-nowrap">
                  2026
                </span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Compra Segura com Hoobuy
            </h2>
            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-3 py-1.5 rounded-full border border-background-300 text-xs font-medium text-foreground-600 whitespace-nowrap">
                EEAT
              </span>
              <span className="px-3 py-1.5 rounded-full text-xs font-medium text-foreground-500 whitespace-nowrap">
                Guia 2026
              </span>
              <span className="px-3 py-1.5 rounded-full text-xs font-medium text-foreground-500 whitespace-nowrap">
                Brasil
              </span>
              <span className="px-3 py-1.5 rounded-full text-xs font-medium text-foreground-500 whitespace-nowrap">
                Verificado
              </span>
            </div>

            <div className="rounded-xl bg-foreground-950 p-6 md:p-8">
              <div className="flex items-center gap-2 mb-4">
                <span className="inline-block px-2.5 py-1 rounded-md bg-primary-500/20 text-[10px] font-bold text-primary-400 uppercase tracking-wider">
                  Segurança
                </span>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-background-50 mb-3">
                Dicas Essenciais para Comprar com Segurança
              </h3>
              <ul className="space-y-3">
                <li className="flex gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 shrink-0">
                    <i className="ri-check-line text-xs text-primary-400"></i>
                  </span>
                  <p className="text-sm text-background-200 leading-relaxed">
                    Compre apenas de fornecedores verificados com histórico comprovado de avaliações positivas e entregas bem-sucedidas.
                  </p>
                </li>
                <li className="flex gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 shrink-0">
                    <i className="ri-check-line text-xs text-primary-400"></i>
                  </span>
                  <p className="text-sm text-background-200 leading-relaxed">
                    Sempre verifique as avaliações recentes e o histórico de envio antes de realizar qualquer compra.
                  </p>
                </li>
                <li className="flex gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 shrink-0">
                    <i className="ri-check-line text-xs text-primary-400"></i>
                  </span>
                  <p className="text-sm text-background-200 leading-relaxed">
                    Compare preços entre diferentes fornecedores para garantir o melhor custo-benefício em suas compras.
                  </p>
                </li>
                <li className="flex gap-3">
                  <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-500/20 mt-0.5 shrink-0">
                    <i className="ri-check-line text-xs text-primary-400"></i>
                  </span>
                  <p className="text-sm text-background-200 leading-relaxed">
                    Utilize os canais oficiais do Hoobuy para comunicação com vendedores e resolução de problemas.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}